<template>
  <button class="btn btn-danger btn-sm" @click.prevent="confirmDeleteEntity()">
    <font-awesome-icon :icon="['fal', 'trash']" />
  </button>
</template>

<script type="text/babel">
export default {
  props: ["entity", "entityName", "refs"],

  methods: {
    confirmDeleteEntity() {
      window
        .sweetAlert({
          title: "Are you sure?",
          text: "Are you sure that you want to delete this record?",
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "No",
            confirm: "Yes, delete!",
          },
        })
        .then(async (confirmed) => {
          if (confirmed) {
            try {
              await this.$http.delete(`/${this.entityName}/${this.entity.id}`);

              this.$nextTick(() => {
                this.refs.table.refresh();
                this.refs.table.setPage(1);
              });
            } catch (error) {
              const message = this.$lodash.get(
                this.$lodash.values(error.body.errors),
                "[0][0]",
                null
              );
              if (message) {
                window.sweetAlert({
                  title: "Failed to delete",
                  text: message,
                  icon: "error",
                });
              }
            }
          }
        });
    },
  },
};
</script>
